
<template>
     <div class="securitygrouprules" v-if="locale.securitygroups">
       <template v-if="loadingState">
         <div class="spinner">
           <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
viewBox="0 0 200 117" style="enable-background:new 0 0 200 117;" xml:space="preserve">
            <g id="triangle8">
                <path class="st0" d="M153,60.4l-22,10.9l22-31.4V60.4z"/>
            </g>
            <g id="triangle7">
                <path class="st1" d="M131,71.2l-24.4-25l46.4-6.5L131,71.2z"/>
            </g>
            <g id="triangle6">
                <path class="st2" d="M131,71.2L111.1,90l-4.5-43.8L131,71.2z"/>
            </g>
            <g id="triangle5">
                <path class="st0" d="M109.6,76.1l-2.2-21.5l0.3,21.4L109.6,76.1z"/>
            </g>
            <g id="triangle4">
                <path class="st1" d="M106.6,46.2l0.8,8.3l0.3,21.4l-23.2-1.5L106.6,46.2z"/>
            </g>
            <g id="triangle3">
                <path class="st3" d="M84.5,74.5L59.6,51l47-4.7L84.5,74.5z"/>
            </g>
            <g id="triangle2">
                <polygon class="st0" points="50.5,52 37.9,30.5 69.7,60.4"/>
            </g>
            <g id="triangle1">
                <path class="st2" d="M50.5,52l-12,18.3L59.6,56L50.5,52z"/>
            </g>
        </svg>
         </div>
       </template>
       <template v-if="!loadingState">
    <div class="content-headline">
      <div class="content-headline__wrapper">
        <h1>{{locale.securitygroups.title}} - {{locale.securitygroups.rules}}</h1>
        <div class="content-headline__control-buttons">
          <button class="action-tooltip button" v-on:click="openModal({ id: 'modalNewGroup'})">{{locale.securitygroups.buttonNewRule}}</button>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <table class="responsive">
        <thead>
        <tr>
          <th scope="col">{{locale.securitygroups.rule.direction}}</th>
          <th scope="col">{{locale.securitygroups.rule.ethertype}}</th>
          <th scope="col">{{locale.securitygroups.rule.protocol}}</th>
          <th scope="col">{{locale.securitygroups.rule.portRangeMin}}</th>
          <th scope="col">{{locale.securitygroups.rule.portRangeMax}}</th>
          <th scope="col">{{locale.securitygroups.rule.remoteIP}}</th>
          <th scope="col"></th>
        </tr>
        </thead>
        <tbody>
        <template v-for="rule in securitygroup.rules">
          <tr :key="rule.id" v-if="rule.protocol != null">
            <td data-label="Direction">{{rule.direction}}</td>
            <td data-label="Ethertype">{{rule.ethertype}}</td>
            <td data-label="Protocol">{{rule.protocol}}</td>
            <td data-label="PortRangeMin">{{rule.portRangeMin}}</td>
            <td data-label="PortRangeMax">{{rule.portRangeMax}}</td>
            <td data-label="RemoteIP">{{rule.remoteIP}}</td>
            <td data-label="Action">
              <a href="#" v-on:click="openModal({ id: 'modalDelete', data: rule})">
                <span class="actions-icon actions-icon--trash"></span>
              </a>
            </td>
          </tr>
        </template>
        </tbody>
      </table>
    </div>

    <ModalBox id="modalNewGroup">
      <template slot="header">
        {{locale.securitygroups.modal.newgroup.title}}:
      </template>
      <template slot="body">
        <errorMessages v-for="error in errors.all()" v-bind:key="error.id" v-bind:error="error"/>

        <form class="form" @submit.prevent="submit">
          <label>{{locale.securitygroups.rule.portRangeMin}}</label>
          <input v-model="form.portRangeMin" v-validate="{required:true}" :data-vv-as="locale.securitygroups.rule.portRangeMin" name="portRangeMin" />
          <label>{{locale.securitygroups.rule.portRangeMax}} </label>
          <input v-model="form.portRangeMax" v-validate="{required:true}" :data-vv-as="locale.securitygroups.rule.portRangeMax" name="portRangeMax" />
          <label>{{locale.securitygroups.rule.protocol}}</label>
          <div class="select-wrapper">
            <select class="select" v-model="form.protocol" v-validate="{required:true}" :data-vv-as="locale.securitygroups.rule.protocol" name="protocol">
              <option value="TCP">TCP</option>
              <option value="UDP">UDP</option>
            </select>
          </div>
          <label>{{locale.securitygroups.rule.remoteIP}}</label>
          <input v-model="form.remoteIpPrefix" name="remoteIP" :data-vv-as="locale.securitygroups.rule.remoteIP" v-validate="{regex: /^(?:[0-9]{1,3}\.){3}[0-9]{1,3}(\/\d{1,2})?$/}"/>
          <div class="modal-buttons">
            <button class="button">{{locale.securitygroups.modal.newgroup.submit}}</button>
          </div>
        </form>
      </template>
    </ModalBox>

    <ModalBox id="modalDelete">
      <template slot="header">
        {{locale.securitygroups.rule.modal.delete.title}}
      </template>
      <template slot="body">
        <div class="modal-buttons">
          <a href="#" class="button button--secondary" v-on:click="closeModal({id: 'modalDelete'})">{{locale.securitygroups.rule.modal.delete.cancel}}</a>
          <a href="#" class="button button--danger"
             v-on:click="deleteRule(modalData) + closeModal({id: 'modalDelete'})">{{locale.securitygroups.rule.modal.delete.button}}</a>
        </div>
      </template>
    </ModalBox>
      </template>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ModalBox from '../utils/modalBox.vue'
import errorMessages from '../utils/errorMessages.vue'

export default {
  name: 'SecurityGroupRules',
  components: { ModalBox, errorMessages },
  computed: {
    ...mapState(['locale']),
    ...mapState({
      securitygroup: state => state.securitygroups.securitygroup,
      loadingState: state => state.loadingState,
      modalData: state => state.modal.modalData
    })
  },
  data: function () {
    return {
      id: 0,
      interval: null,
      modalState: true,
      form: [
      ]
    }
  },
  mounted () {
    this.$store.dispatch('securitygroups/getSecurityGroup', {'id': this.id, 'loading': 1})
    this.interval = setInterval(function () {
      this.refresh()
    }.bind(this), 1000)
  },
  created () {
    this.id = this.$route.params.id
    this.$store.dispatch('securitygroups/getSecurityGroup', {'id': this.id})
  },
  methods: {
    ...mapActions({
      deleteRule: 'securitygrouprules/deleteRule',
      openModal: 'modal/openModal',
      closeModal: 'modal/closeModal'
    }),
    submit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.form.id = this.$route.params.id
          this.form.direction = 'ingress'
          this.form.ethertype = 'IPv4'
          this.$store.dispatch('securitygrouprules/createNewRule', this.form).then((response) => {
            this.$store.dispatch('securitygroups/getSecurityGroup', {'id': this.id})
            this.form = []
          })
          this.closeModal({id: 'modalNewGroup'})
        }
      })
    },
    refresh: function () {
      this.$store.dispatch('securitygroups/getSecurityGroup', {'id': this.id, 'loading': 0})
    }
  },
  beforeDestroy: function () {
    clearInterval(this.interval)
    this.id = 0
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SecurityGroupRules.vue